import React from 'react'

const Lembaga = () => {
  return (
    <div>Lembaga</div>
  )
}

export default Lembaga